<template>
  <div class="newplace">
    <div class='full_layout'>
      <!-- <img class="moon" src="/static/images/activty/festival/midautumn/midautumn/midautumnMoon.png"> -->
      <img class="text" src="/static/images/activty/festival/midautumn/midautumn/midautumnText.png">
    </div>
  </div>
</template>
<script>
import bus from '@/api/bus';
export default {
  name: '',
  components: {},
  data() {
    return {}
  },
  watch: {},
  mounted() {},
  created() {
    bus.$emit('headerTitle', this.$t('base.notice'));
  },
  methods: {

  },
}

</script>
<style scoped>
  .newplace{
    background: url(../../../../static/images/activty/festival/midautumn/midautumn/midautumnBg.jpg) center 0 no-repeat;
  }
.newplace img {
  width: 100%;
  display: block;
  overflow: hidden;
  margin: 0 auto;
}
.newplace .full_layout{
  height: 836px;
}
.newplace .moon{
  width: 360px;
  margin: 32px auto 27px;
}
.newplace .text{
  width: 800px;
  margin-top: 117px;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/festival/midautumn.vue